<script setup lang="ts">
import { gaiaFontSize, gaiaFontWeight, gaiaNeutral } from '../themes/tokens';
import GaiaCheckbox from './GaiaCheckbox.vue';

const props = defineProps({
  checked: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{ 'update:checked': [checked: boolean] }>();

const border = gaiaNeutral.border;
const borderHover = gaiaNeutral.borderHover;
const surface = gaiaNeutral.surface;
const tint = gaiaNeutral.surfaceTint;
const text = gaiaNeutral.text;
// The chip is a bordered button with its own state, so its type reaches it
// through v-bind rather than a GaiaText prop.
const size = gaiaFontSize.dense;
const medium = String(gaiaFontWeight.medium);
</script>

<template>
  <!-- A checkbox wearing a chip ("Include archived" on the requests list,
       "Sign in order" in the wizard): one control-height target rather than a
       bare n-checkbox floating in a toolbar row. The checkbox itself is the
       themed n-checkbox; the chip around it is ours. -->
  <button
    type="button"
    class="gaia-check-chip"
    :class="{ on: props.checked }"
    :aria-pressed="props.checked"
    @click="emit('update:checked', !props.checked)"
  >
    <gaia-checkbox
      :checked="props.checked"
      size="small"
      tabindex="-1"
      style="pointer-events: none"
    />
    <slot />
  </button>
</template>

<style scoped>
.gaia-check-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 13px;
  border: 1px solid v-bind(border);
  border-radius: 9px;
  background: v-bind(surface);
  font-family: inherit;
  font-size: v-bind(size);
  font-weight: v-bind(medium);
  color: v-bind(text);
  white-space: nowrap;
  cursor: pointer;
}

.gaia-check-chip:hover {
  border-color: v-bind(borderHover);
}

.gaia-check-chip.on {
  background: v-bind(tint);
}
</style>
